import React from "react";
import { Container } from "reactstrap";
import Moment from "moment";
import ContactLoader from "views/ContantLoader";
import { getToken } from "Utils/Common";
import "../styles.css";
import { getCompany, getPersonAnalytics } from "api/AccountsApi";
import { useHistory } from 'react-router-dom';

export default class AllAccount extends React.Component {
  state = {
    data: [],
    tags: [],
    dontLoad: false,
    fromdate: "",
    todate: "",
    companyName: "",
    
  };

  
  setBarSizes(d) {


    var bar1 = d.newPersonAdded;
    var bar2 = d.subscribe;

    var bar3 = d.unSubscribe;

    var x = document.getElementsByClassName("progress")[0].offsetWidth;
    var bars = document.getElementsByClassName("animate-progress");
    // bars[0].style.width=""+(0.5*x)+"px";

    var ratio = bar1 + bar2 + bar3;

    // document.getElementById("b1").style.width = ""+((this.state.data.newPersonAdded/ratio)*x)+"px";






    bars[0].style.width = "" + (bar1 / ratio) * 100 + "%";
    bars[1].style.width = "" + (bar2 / ratio) * 100 + "%";
    bars[2].style.width = "" + (bar3 / ratio) * 100 + "%";
  }
  componentDidMount() {
    const token = "Bearer " + getToken();
    const options = {
      headers: { Authorization: token },
    };
    getPersonAnalytics()
      .then((data) => {
        this.setState({ data });
        const fromdate = Moment(data.period.fromDate).format("MMM D,YYYY");
        this.setState({ fromdate });
        const todate = Moment(data.period.toDate).format("MMM D,YYYY");
        this.setState({ todate });
        let tags = data.topTags;
        this.setState({ tags });
        this.setBarSizes(data);
      })
      .catch((e) => { })
    getCompany()
      .then((data) => {
        this.setState({ companyName: data.name });
      })
      .catch((e) => { })

    window.onload = function () {
      if (
        document.querySelectorAll(".progress").length > 0 &&
        document.querySelectorAll(".progress [data-progress]").length > 0
      ) {
        document
          .querySelectorAll(".progress [data-progress]")
          .forEach((x) => AnimateProgress(x));
      }
    };
    setTimeout(() => {
      this.setState({ dontLoad: true });
    }, 10000);
    function AnimateProgress(el) {
      el.className = "animate-progress";
      el.setAttribute("style", `width:${el.getAttribute("data-progress")}%;`);
    }
  }

  render() {
    // var x=document.gdocument.getElementById('bar1').offsetWidth;
    //  const barStyle1 = {
    //   color: "white",
    //   backgroundColor: "DodgerBlue",
    //   fontFamily: "Arial",
    //   width: this.state.data.newPersonAdded,
    //   padding: (x-this.state.data.newPersonAdded)

    // };

    return (
      <>

<div className="contact-main-card">
          <div className="ct-card">
            <div className="ctc-top">New Contacts</div>

            <div className="ctc-bottom">
              {this.state.data.newPersonAdded}  
              </div>
            <div className="ctc-foot">
              From {this.state.fromdate} to {this.state.todate}
              </div>
            </div>


          <div className="ct-card">
            <div className="ctc-top">Subscribed</div>

            <div className="ctc-bottom">
              {this.state.data.subscribe}

              </div>
            <div className="ctc-foot">
              From {this.state.fromdate} to {this.state.todate}

              </div>
            

          </div>

          <div className="ct-card">
            <div className="ctc-top">Unsubscribed</div>

            <div className="ctc-bottom">
              {this.state.data.unSubscribe}


              </div>
            <div className="ctc-foot">
              From {this.state.fromdate} to {this.state.todate}

              </div>
          </div>


    </div>


    <div className="eBox" style={{maxHeight:"500px", marginTop:0}} >
                    <div style={{ marginBottom: '20px' }}>
                        <div className="pgtop">
                            <span>Top Tags</span>
                  

                        </div>
                        <table className="pageTable" style={{height:"none !important"}}>
                            {/* <colgroup>
                                <col span="1" style="width: 15%;">
                                    <col span="1" style="width: 70%;">
                            </colgroup> */}
                            <tbody>
                                <tr style={{ border: 'none' }}>
                                    <th style={{ width: '90%' }}>Tag</th>
                                    <th style={{ width: '20%' }}>Count</th>

                                </tr>
                                {
                                     this.state.tags && this.state.tags.length &&this.state.tags.slice(0, 4).map((e, i) => {
                                        return <tr>
                                            <td><h6 className="wrap" style={{ width: "400px" }}>{e.tag}</h6></td>
                                            <td>

                                                <h1 className="num2" title="View"
                                                    style={{ fontSize: '12px' }}
                                                    onClick={() => {
     



                                                       window.location.pathname  =`/admin/contact/list?tag=${e.tag}`
                                                       sessionStorage.setItem("E__tag", e.tag)

                                                    }
                                                    }
                                                >{e.count}</h1>

                                            </td>

                                        </tr>
                                    })
                                }
                            </tbody>

                        </table>

                        <div className="jofe">

                        <a href="/admin/contact/list" className="text_btn">
                        More Tags{" "}
                        <span className="icon-arrow-down-sign-to-navigate"></span>
                        <span className="icon-arrow-down-sign-to-navigate"></span>
                      </a>
                        </div>
                
                    </div>


                </div>





  





        
    
      </>
    );
  }
}
